import React, { useState } from "react";
import {
  Button,
  Fade,
  Input,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Container,
  Col,
  Row,
} from "reactstrap";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form1 from "./Form 11 Case/Form1";
import { useNavigatorState } from "../Context/NavigatorState";

const baseURL = process.env.REACT_APP_API_CORS;

const SelectLeaveForm = ({
  paramValue,
  paramValue2,
  getLeaveData,
  RefreshLeaveDataTable,
  userInfo,
  activeTabNav,
  setActiveTabNav,
  isFromIndex,
}) => {
  const navigate = useNavigate();
  const token = GetCookieToken("userToken");
  const { navigateState, setNavigateState } = useNavigatorState();

  const [configForm, setConfigForm] = useState([]);
  const [open, setOpen] = useState(false);
  const [formNum, setFormNum] = useState(paramValue2 ? paramValue2 : null);

    const getData = async () => {
        await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => {
          getConfigAll(res?.data?.result);
        })
    };
  
  const getConfigAll = async (user) => {
    try {
      const res = await axios.get(baseURL + "/api/leave/config/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      let formLeave = user?.user_employee_type_id === 2 ? 
        (res?.data?.form_leave).filter((item) => (item.form_type === 1) || (item.form_type === 10) || (item.form_type === 9))
         : (res?.data?.form_leave).filter((item) => item.form_type !== 12);

      setConfigForm(formLeave);
      
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const openCanvas = () => {
    setOpen(true);
  };
  const closeCanvas = () => {
    setOpen(false);
    setFormNum("");
    setNavigateState(null)
    if (paramValue === "1") {
      navigate("/leave");
    }
  };

  return (
    <React.Fragment>
      <div>
        <Button className="pb-0" color="info" onClick={openCanvas}>
          <h6><b className="font-size-18" style={{whiteSpace:"nowrap"}}><i className="fa-solid fa-plus me-1"></i>ฟอร์มการลา</b></h6>
        </Button>

        <Offcanvas
          // style={{ width: "50%" }}
          direction="end"
          isOpen={paramValue === "1" || open}
          toggle={() => {
            closeCanvas();
          }}
          className="custom-w-50"
        >
          <OffcanvasHeader className="bg-light" toggle={closeCanvas}>
            เพิ่มฟอร์มการลา
          </OffcanvasHeader>
          <OffcanvasBody>
            <Container fluid>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Label className="text-end" xxl={3} lg={4} md={4}>
                  ประเภทการลา
                </Label>
                <Col xxl={5} lg={5} md={8}>
                  <Input
                    className="my-3"
                    type="select"
                    value={formNum}
                    onChange={(e) => setFormNum((prev) => Number(e.target.value))}
                  >
                    <option value="">กรุณาระบุ</option>
                    {configForm?.map((item, idx, arr) => {
                        if (userInfo?.user_trial === "1" && (item?.form_type === 2)) {
                          return null
                        }
                        return (
                          <option key={idx} value={item?.form_type}>
                            {item?.form_name}
                          </option>
                        );
                    })}
                  </Input>
                </Col>
              </Row>
              {formNum === "" ? null : (
                <>
                  <Form1
                    paramValue={paramValue}
                    paramValue2={paramValue2}
                    userInfo={userInfo}
                    configForm={configForm.find((item) => item.form_type === formNum)}
                    closeCanvas={closeCanvas}
                    getLeaveData={getLeaveData}
                    RefreshLeaveDataTable={RefreshLeaveDataTable}
                    activeTabNav={activeTabNav}
                    setActiveTabNav={setActiveTabNav}
                    isFromIndex={isFromIndex}
                    navigateState={navigateState}
                  />
                </>
              )}
            </Container>
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};

export default SelectLeaveForm;
